let resumeData = {
  imagebaseurl: "https://npa528.github.io/",
  name: "Nikos Papadakis",
  role: "Full Stack Blockchain Developer",
  linkedinId: "https://www.linkedin.com/in/papadakisnik/",
  image: "profilepic.jpg",
  email: "npapadakis@gmail.com",
  resumedownload:
    "https://drive.google.com/drive/folders/1lAq9qDiwdTdIEz5hvrxp0ss4wbRNbKjD",
  bio:
    "I am software developer interested in Blockchain ecosystem, security and coding in general. Through my career, I developed applications using different tools and programming languages. I have confidence of using something new to me and with hard work and research I can deliver results quickly. I would like to have the chance to work in a Web 3.0 company that uses Blockchain technology, develops smart contract or any other company that wants a Backend developer with some experience in Java EE.",
  contactmessage:
    "Think I'd be a good fit for your team? I'd love to hear from you, give me a shout by email or by using the form below if you'd like to get in contact with me.",

  roleDescription:
    "I like coding in various parts of development and I like to learn about new technologies.",
  socialLinks: [
    {
      name: "linkedin",
      url: "https://www.linkedin.com/in/papadakisnik/",
      className: "fa fa-linkedin",
    },
    {
      name: "github",
      url: "https://github.com/npa528",
      className: "fa fa-github",
    },
  ],
  aboutme:
    "I am a self taught Blockchain Developer, currently diving deeper into Ethereum Blockchain. I believe that to be successful in life, one needs to be obsessive with their dreams and keep working towards them.",
  address: {
    city: "Heraklion Crete",
    country: "Greece",
  },
  website: "https://npa528.github.io",
  education: [
    {
      UniversityName: "University of York",
      specialization: "MSc in Internet and Wireless Computing",
      MonthOfPassing: "Sep",
      YearOfPassing: "2010",
      Achievements:
        "Core Modules: JAVA OOP, Personal and Mobile Communications, Advanced Internet Protocols, Network Security, Embedded Computer Systems",
    },
    {
      UniversityName: "Technological Education Institute of Crete",
      specialization: "BSc in Applied Information Technology and Multimedia",
      MonthOfPassing: "Jun",
      YearOfPassing: "2009",
      Achievements:
        "Core Modules:• Programming (C, C++, Java, Matlab, JavaScript, PHP) • Databases • Computer - Wireless Networks • Microprocessors • Information Systems Security",
    },
  ],
  work: [
    {
      CompanyName: "Netmechanics LLC",
      specialization: "Software Developer",
      MonthOfJoining: "May",
      YearOfJoining: "2018",
      MonthOfLeaving: "Feb",
      YearOfLeaving: "2021",
      Achievements:
        "I developed Web Applications in Java EE 8. Some of the technologies I used are: Java EE 8, JPA, JAXRS, Maven, Apache Velocity template, Vaadin 8, Apache NiFi, Power BI, Microsoft Azure",
    },
    {
      CompanyName: "Empelor GmbH",
      specialization: "Software Developer",
      MonthOfJoining: "Nov",
      YearOfJoining: "2012",
      MonthOfLeaving: "Aug",
      YearOfLeaving: "2017",
      Achievements:
        "Configuration and minor implementation of an iOS software (static library) for online banking and payment applications (EBICS) using smart cards, for the security device Secocard that Empelor is developing (communication of iOS device and Secocard was via Bluetooth).iOS static library development of pseudo PC/SC layer that communicates also directly to the Smart Card inserted in Secocard (using APDUs).• iOS static library Public Key Infrastructure environment (PKI) for security methods for generating cryptographic keys (RSA cryptosystem) and for encrypting / decrypting data on the Smart Card. • Blackberry 10 smart card driver for S/MIME. PKI crypto library for Blackberry mobile device which communicates with an mSD smart card inserted in the internal mSD slot. • Reference code for Android application for NXP MIFARE DESFire contactless smart cards which can be thought as a memory card with access control. This app uses NFC technology to read/write data to a DESFire card via NFC.",
    },
  ],
  skillsDescription:
    "I am interested in playing around with new technologies but these are the ones that have really won me over",
  skills: [
    {
      name: "Git",
      description:
        "I use Git for all of my projects so far. I have used Git for version control in small teams and have toyed around with contributing to Open Source Projects.",
      image: "git.jpg",
    },
    {
      name: "Java",
      description:
        "Java was my first programming language that I started using in college years ago. It is by far the language I am most familiar with in terms of data-structure and algorithm programming.",
      image: "java.jpg",
    },
    {
      name: "React Js",
      description:
        "I am fairly new to React and really did not like it at first. It has grown on me though and I will continue to use it going forward. I have built a ReactJS based resume-website template (link below in portfolio) which I used as a starting point for this personal site.",
      image: "react.jpg",
    },
    {
      name: "Solidity",
      description: "Solidity for developing smart contracts",
      image: "solidity.png",
    },
    {
      name: "Node JS",
      description:
        "Node JS is my server-side scripting language of choice. The bulk of my experience with it has been in conjunction with MeteorJS-based projects",
      image: "node.jpg",
    },
    {
      name: "Ethereum",
      description: "Ethereum platform",
      image: "eth.jpg",
    },
    {
      name: "Hardhat",
      description: "Hardhat ethereum development environment",
      image: "hardhat.png",
    },
    {
      name: "Chai",
      description:
        "Chai is a BDD / TDD assertion library for node and the browser that can be delightfully paired with any javascript testing framework.",
      image: "chai.png",
    },
  ],
  portfolio: [
    {
      name: "blockchain-exchange",
      description: "blockchain exchange",
      img: "blockchain-exchange.png",
      url: "https://npa528.github.io/blockchain-exchange-v2/",
    },
    {
      name: "nft-marketplace",
      description: "NFT marketplace using The Graph",
      img: "nftmarketplace.png",
      url: "https://npa528.github.io/nextjs-nft-marketplace-thegraph/",
    },{
      name: "earthquakes-greece",
      description: "Earthquake events in Greece",
      img: "earthquakesgreece.png",
      url: "https://earthquakes-greece-next.vercel.app/",
    },
  ],
};

export default resumeData;
